// import { updateFunctionalityPayload } from '../types/permissions.types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

export const getClientPermissionsByPortalIdApi = async (
  clientId?: string | number
) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}permission-set/user`,
    clientId
      ? {
          headers: {
            'X-TenantId': clientId,
          },
        }
      : {}
  )
}

// export const getPermissionsOfFunctionalitiesByIdApi = async (payload: {
//   id: number
// }) => {
//   // return await axiosInstance.get(`${API_END_POINT.CORE}roles-functionality/permissions/${payload.id}`, {})
//   return await axiosInstance.get(
//     `${API_END_POINT.CORE}roles/${payload.id}/rolePermissions`,
//     {}
//   )
// }

export const getFieldPermissionsApi = async () => {
  return await axiosInstance.get(
    `${API_END_POINT.V0_ENTITY_MANAGER}/permission/aggregated-permissions`
  )
}

// export const putPermissionsOfFunctionalitiesByIdApi = async (
//   payload: updateFunctionalityPayload
// ) => {
//   // return await axiosInstance.put(`${API_END_POINT.CORE}roles-functionality/permissions/${payload.id}`, payload.data);
//   return await axiosInstance.put(
//     `${API_END_POINT.CORE}roles/${payload.id}/rolePermissions`,
//     payload.data
//   )
// }

export const getPermissionsByProgramId = async (
  programId: string | number,
  selectedTenantId: string | number
) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}users/profile?programId=${programId}`,
    {
      headers: {
        'X-TenantId': selectedTenantId,
      },
    }
  )
}
